import { render, staticRenderFns } from "./AggregateReporting.vue?vue&type=template&id=530ba75e&scoped=true"
import script from "./AggregateReporting.vue?vue&type=script&lang=js"
export * from "./AggregateReporting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530ba75e",
  null
  
)

export default component.exports